const cache = /* @__PURE__ */ new Map();
const cacheFetch = async (uri) => {
  if (!cache.has(uri)) {
    const value = fetch(uri).then((response) => response.text());
    cache.set(uri, value);
  }
  return cache.get(uri);
};
export {
  cacheFetch
};
//# sourceMappingURL=cache-fetch.js.map
